import React, { useState, useEffect } from 'react';
import HeroSection from '../components/HeroSection';

const Home: React.FC = () => {
    // State to store the content from the JSON file
    const [homeContent, setHomeContent] = useState<any>(null);

    // Fetch the JSON content dynamically when the component mounts
    useEffect(() => {
        fetch('/content/Home.json') // Path to the JSON file in the public directory
            .then((response) => response.json())
            .then((data) => setHomeContent(data)) // Store the JSON data in state
            .catch((error) => console.error('Error loading JSON:', error));
    }, []); // Empty dependency array ensures this runs only once when the component mounts

    // Display a loading state until the JSON data is fetched
    if (!homeContent) {
        return (
            <div className="flex items-center justify-center min-h-[50vh]">
                <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-300 border-t-logoPurple" />
            </div>
        );
    }

    // Destructure the fetched JSON data
    const { heroSection, homePageContent } = homeContent;

    console.log(heroSection);

    return (
        <div>
            {/* Hero Section */}
            <HeroSection
                backgroundImage={heroSection.backgroundImage}
                headingText={heroSection.headingText}
                subHeadingText={heroSection.subHeadingText}
                heightSize={heroSection.heightSize}
                profileImage={heroSection.profileImage}
            />

            <div className="p-8 mt-12">
                <div className="max-w-3xl mx-auto">
                    <h1 className="text-center text-4xl font-bold text-logoPurple">
                        {homePageContent.heading}
                    </h1>

                    {/* Render the paragraphs dynamically */}
                    {homePageContent.paragraphs.map((paragraph: string, index: number) => (
                        <p key={index} className="mt-4 text-gray-600 text-center">
                            {paragraph}
                        </p>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Home;
